// extracted by mini-css-extract-plugin
export default {"button":"style_button__9ZyTk","button__yellow":"style_button__yellow__VY+8v","button__img":"style_button__img__r7QBB","button__img_card":"style_button__img_card__X9oQZ"};